module.exports = __webpack_public_path__ + "static/media/Home-1.47425363.jpg";